import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import Privacy from './Privacy';

const mapStateToProps = (state: any) => ({
  globalTrackerSettings: state.trackerSettings.global.settings,
  appTrackerSettings: state.trackerSettings.app.settings,
});

export const ConnectedPrivacy = connect(mapStateToProps, null)(Privacy);

export default withTranslation(['administration'])(ConnectedPrivacy as any);
